import type { GenericTranslationsObject } from '@payloadcms/translations'

export const es: GenericTranslationsObject = {
  $schema: '../translation-schema.json',
  'plugin-redirects': {
    customUrl: 'URL personalizada',
    documentToRedirect: 'Documento al que redirigir',
    fromUrl: 'URL de origen',
    internalLink: 'Enlace interno',
    redirectType: 'Tipo de redirección',
    toUrlType: 'Tipo de URL de destino',
  },
}
